export { showFlashMessage as default } from 'shared/common/flashMessages'
